import i18n from '../i18n/config';

//------------------------- Error Boundary Messages -----------------------------//

export const genericApplicationErrorMessage = i18n.t(
  'errors.errorOccurredWithDocument',
);

//------------------------- Notification Toast Messages -----------------------------//

export const savingFailedErrorMessage = i18n.t('errors.errorSavingDocument');

export const savingFailedCloudSectionVersion = (sectionNumber: any) =>
  i18n.t('errors.couldNotSaveChangeSectionOutdated', { sectionNumber });
